const prefixes = {
    Afghanistan: { iso2: 'AF', iso3: 'AFG', prefix: '+93' },
    Albania: { iso2: 'AL', iso3: 'ALB', prefix: '+355' },
    Germany: { iso2: 'DE', iso3: 'DEU', prefix: '+49' },
    Algeria: { iso2: 'DZ', iso3: 'DZA', prefix: '+213' },
    Andorra: { iso2: 'AD', iso3: 'AND', prefix: '+376' },
    Angola: { iso2: 'AO', iso3: 'AGO', prefix: '+244' },
    Anguilla: { iso2: 'AI', iso3: 'AIA', prefix: '+1 264' },
    Antarctica: { iso2: 'AQ', iso3: 'ATA', prefix: '+672' },
    'Antigua and Barbuda': { iso2: 'AG', iso3: 'ATG', prefix: '+1 268' },
    'Netherlands Antilles': { iso2: 'AN', iso3: 'ANT', prefix: '+599' },
    'Saudi Arabia': { iso2: 'SA', iso3: 'SAU', prefix: '+966' },
    Argentina: { iso2: 'AR', iso3: 'ARG', prefix: '+54' },
    Armenia: { iso2: 'AM', iso3: 'ARM', prefix: '+374' },
    Aruba: { iso2: 'AW', iso3: 'ABW', prefix: '+297' },
    Australia: { iso2: 'AU', iso3: 'AUS', prefix: '+61' },
    Austria: { iso2: 'AT', iso3: 'AUT', prefix: '+43' },
    Azerbaijan: { iso2: 'AZ', iso3: 'AZE', prefix: '+994' },
    Belgium: { iso2: 'BE', iso3: 'BEL', prefix: '+32' },
    Bahamas: { iso2: 'BS', iso3: 'BHS', prefix: '+1 242' },
    Bahrain: { iso2: 'BH', iso3: 'BHR', prefix: '+973' },
    Bangladesh: { iso2: 'BD', iso3: 'BGD', prefix: '+880' },
    Barbados: { iso2: 'BB', iso3: 'BRB', prefix: '+1 246' },
    Belize: { iso2: 'BZ', iso3: 'BLZ', prefix: '+501' },
    Benin: { iso2: 'BJ', iso3: 'BEN', prefix: '+229' },
    Bhutan: { iso2: 'BT', iso3: 'BTN', prefix: '+975' },
    Belarus: { iso2: 'BY', iso3: 'BLR', prefix: '+375' },
    Myanmar: { iso2: 'MM', iso3: 'MMR', prefix: '+95' },
    Bolivia: { iso2: 'BO', iso3: 'BOL', prefix: '+591' },
    'Bosnia and Herzegovina': { iso2: 'BA', iso3: 'BIH', prefix: '+387' },
    Botswana: { iso2: 'BW', iso3: 'BWA', prefix: '+267' },
    Brazil: { iso2: 'BR', iso3: 'BRA', prefix: '+55' },
    Brunei: { iso2: 'BN', iso3: 'BRN', prefix: '+673' },
    Bulgaria: { iso2: 'BG', iso3: 'BGR', prefix: '+359' },
    'Burkina Faso': { iso2: 'BF', iso3: 'BFA', prefix: '+226' },
    Burundi: { iso2: 'BI', iso3: 'BDI', prefix: '+257' },
    'Cape Verde': { iso2: 'CV', iso3: 'CPV', prefix: '+238' },
    Cambodia: { iso2: 'KH', iso3: 'KHM', prefix: '+855' },
    Cameroon: { iso2: 'CM', iso3: 'CMR', prefix: '+237' },
    Canada: { iso2: 'CA', iso3: 'CAN', prefix: '+1' },
    Chad: { iso2: 'TD', iso3: 'TCD', prefix: '+235' },
    Chile: { iso2: 'CL', iso3: 'CHL', prefix: '+56' },
    China: { iso2: 'CN', iso3: 'CHN', prefix: '+86' },
    Cyprus: { iso2: 'CY', iso3: 'CYP', prefix: '+357' },
    'Vatican City State': { iso2: 'VA', iso3: 'VAT', prefix: '+39' },
    Colombia: { iso2: 'CO', iso3: 'COL', prefix: '+57' },
    Comoros: { iso2: 'KM', iso3: 'COM', prefix: '+269' },
    Congo: { iso2: 'CD', iso3: 'COD', prefix: '+243' },
    'North Korea': { iso2: 'KP', iso3: 'PRK', prefix: '+850' },
    'South Korea': { iso2: 'KR', iso3: 'KOR', prefix: '+82' },
    'Ivory Coast': { iso2: 'CI', iso3: 'CIV', prefix: '+225' },
    'Costa Rica': { iso2: 'CR', iso3: 'CRI', prefix: '+506' },
    Croatia: { iso2: 'HR', iso3: 'HRV', prefix: '+385' },
    Cuba: { iso2: 'CU', iso3: 'CUB', prefix: '+53' },
    Denmark: { iso2: 'DK', iso3: 'DNK', prefix: '+45' },
    Dominica: { iso2: 'DM', iso3: 'DMA', prefix: '+1 767' },
    Ecuador: { iso2: 'EC', iso3: 'ECU', prefix: '+593' },
    Egypt: { iso2: 'EG', iso3: 'EGY', prefix: '+20' },
    'El Salvador': { iso2: 'SV', iso3: 'SLV', prefix: '+503' },
    'United Arab Emirates': { iso2: 'AE', iso3: 'ARE', prefix: '+971' },
    Eritrea: { iso2: 'ER', iso3: 'ERI', prefix: '+291' },
    Slovakia: { iso2: 'SK', iso3: 'SVK', prefix: '+421' },
    Slovenia: { iso2: 'SI', iso3: 'SVN', prefix: '+386' },
    Spain: { iso2: 'ES', iso3: 'ESP', prefix: '+34' },
    'United States of America': { iso2: 'US', iso3: 'USA', prefix: '+1' },
    Estonia: { iso2: 'EE', iso3: 'EST', prefix: '+372' },
    Ethiopia: { iso2: 'ET', iso3: 'ETH', prefix: '+251' },
    Philippines: { iso2: 'PH', iso3: 'PHL', prefix: '+63' },
    Finland: { iso2: 'FI', iso3: 'FIN', prefix: '+358' },
    Fiji: { iso2: 'FJ', iso3: 'FJI', prefix: '+679' },
    France: { iso2: 'FR', iso3: 'FRA', prefix: '+33' },
    Gabon: { iso2: 'GA', iso3: 'GAB', prefix: '+241' },
    Gambia: { iso2: 'GM', iso3: 'GMB', prefix: '+220' },
    Georgia: { iso2: 'GE', iso3: 'GEO', prefix: '+995' },
    Ghana: { iso2: 'GH', iso3: 'GHA', prefix: '+233' },
    Gibraltar: { iso2: 'GI', iso3: 'GIB', prefix: '+350' },
    Grenada: { iso2: 'GD', iso3: 'GRD', prefix: '+1 473' },
    Greece: { iso2: 'GR', iso3: 'GRC', prefix: '+30' },
    Greenland: { iso2: 'GL', iso3: 'GRL', prefix: '+299' },
    Guam: { iso2: 'GU', iso3: 'GUM', prefix: '+1 671' },
    Guatemala: { iso2: 'GT', iso3: 'GTM', prefix: '+502' },
    Guernsey: { iso2: 'GG', iso3: 'GGY', prefix: '+44' },
    Guinea: { iso2: 'GN', iso3: 'GIN', prefix: '+224' },
    'Equatorial Guinea': { iso2: 'GQ', iso3: 'GNQ', prefix: '+240' },
    'Guinea-Bissau': { iso2: 'GW', iso3: 'GNB', prefix: '+245' },
    Guyana: { iso2: 'GY', iso3: 'GUY', prefix: '+592' },
    Haiti: { iso2: 'HT', iso3: 'HTI', prefix: '+509' },
    Honduras: { iso2: 'HN', iso3: 'HND', prefix: '+504' },
    'Hong Kong': { iso2: 'HK', iso3: 'HKG', prefix: '+852' },
    Hungary: { iso2: 'HU', iso3: 'HUN', prefix: '+36' },
    India: { iso2: 'IN', iso3: 'IND', prefix: '+91' },
    Indonesia: { iso2: 'ID', iso3: 'IDN', prefix: '+62' },
    Iran: { iso2: 'IR', iso3: 'IRN', prefix: '+98' },
    Iraq: { iso2: 'IQ', iso3: 'IRQ', prefix: '+964' },
    Ireland: { iso2: 'IE', iso3: 'IRL', prefix: '+353' },
    Kosovo: { iso2: 'XK', iso3: 'XXK', prefix: '+383' },
    'Isle of Man': { iso2: 'IM', iso3: 'IMN', prefix: '+44' },
    'Christmas Island': { iso2: 'CX', iso3: 'CXR', prefix: '+61' },
    'Norfolk Island': { iso2: 'NF', iso3: 'NFK', prefix: '+672' },
    Iceland: { iso2: 'IS', iso3: 'ISL', prefix: '+354' },
    'Bermuda Islands': { iso2: 'BM', iso3: 'BMU', prefix: '+1 441' },
    'Cayman Islands': { iso2: 'KY', iso3: 'CYM', prefix: '+1 345' },
    'Cocos (Keeling) Islands': { iso2: 'CC', iso3: 'CCK', prefix: '+61' },
    'Cook Islands': { iso2: 'CK', iso3: 'COK', prefix: '+682' },
    'Faroe Islands': { iso2: 'FO', iso3: 'FRO', prefix: '+298' },
    Maldives: { iso2: 'MV', iso3: 'MDV', prefix: '+960' },
    'Falkland Islands (Malvinas)': { iso2: 'FK', iso3: 'FLK', prefix: '+500' },
    'Northern Mariana Islands': { iso2: 'MP', iso3: 'MNP', prefix: '+1 670' },
    'Marshall Islands': { iso2: 'MH', iso3: 'MHL', prefix: '+692' },
    'Pitcairn Islands': { iso2: 'PN', iso3: 'PCN', prefix: '+870' },
    'Solomon Islands': { iso2: 'SB', iso3: 'SLB', prefix: '+677' },
    'Turks and Caicos Islands': { iso2: 'TC', iso3: 'TCA', prefix: '+1 649' },
    'Virgin Islands': { iso2: 'VG', iso3: 'VG', prefix: '+1 284' },
    'United States Virgin Islands': { iso2: 'VI', iso3: 'VIR', prefix: '+1 340' },
    Israel: { iso2: 'IL', iso3: 'ISR', prefix: '+972' },
    Italy: { iso2: 'IT', iso3: 'ITA', prefix: '+39' },
    Jamaica: { iso2: 'JM', iso3: 'JAM', prefix: '+1 876' },
    Japan: { iso2: 'JP', iso3: 'JPN', prefix: '+81' },
    Jordan: { iso2: 'JO', iso3: 'JOR', prefix: '+962' },
    Kazakhstan: { iso2: 'KZ', iso3: 'KAZ', prefix: '+7' },
    Kenya: { iso2: 'KE', iso3: 'KEN', prefix: '+254' },
    Kyrgyzstan: { iso2: 'KG', iso3: 'KGZ', prefix: '+996' },
    Kiribati: { iso2: 'KI', iso3: 'KIR', prefix: '+686' },
    Kuwait: { iso2: 'KW', iso3: 'KWT', prefix: '+965' },
    Lebanon: { iso2: 'LB', iso3: 'LBN', prefix: '+961' },
    Laos: { iso2: 'LA', iso3: 'LAO', prefix: '+856' },
    Lesotho: { iso2: 'LS', iso3: 'LSO', prefix: '+266' },
    Latvia: { iso2: 'LV', iso3: 'LVA', prefix: '+371' },
    Liberia: { iso2: 'LR', iso3: 'LBR', prefix: '+231' },
    Libya: { iso2: 'LY', iso3: 'LBY', prefix: '+218' },
    Liechtenstein: { iso2: 'LI', iso3: 'LIE', prefix: '+423' },
    Lithuania: { iso2: 'LT', iso3: 'LTU', prefix: '+370' },
    Luxembourg: { iso2: 'LU', iso3: 'LUX', prefix: '+352' },
    Mexico: { iso2: 'MX', iso3: 'MEX', prefix: '+52' },
    Monaco: { iso2: 'MC', iso3: 'MCO', prefix: '+377' },
    Macao: { iso2: 'MO', iso3: 'MAC', prefix: '+853' },
    Macedonia: { iso2: 'MK', iso3: 'MKD', prefix: '+389' },
    Madagascar: { iso2: 'MG', iso3: 'MDG', prefix: '+261' },
    Malaysia: { iso2: 'MY', iso3: 'MYS', prefix: '+60' },
    Malawi: { iso2: 'MW', iso3: 'MWI', prefix: '+265' },
    Mali: { iso2: 'ML', iso3: 'MLI', prefix: '+223' },
    Malta: { iso2: 'MT', iso3: 'MLT', prefix: '+356' },
    Morocco: { iso2: 'MA', iso3: 'MAR', prefix: '+212' },
    Mauritius: { iso2: 'MU', iso3: 'MUS', prefix: '+230' },
    Mauritania: { iso2: 'MR', iso3: 'MRT', prefix: '+222' },
    Mayotte: { iso2: 'YT', iso3: 'MYT', prefix: '+262' },
    'Estados Federados de': { iso2: 'FM', iso3: 'FSM', prefix: '+691' },
    Moldova: { iso2: 'MD', iso3: 'MDA', prefix: '+373' },
    Mongolia: { iso2: 'MN', iso3: 'MNG', prefix: '+976' },
    Montenegro: { iso2: 'ME', iso3: 'MNE', prefix: '+382' },
    Montserrat: { iso2: 'MS', iso3: 'MSR', prefix: '+1 664' },
    Mozambique: { iso2: 'MZ', iso3: 'MOZ', prefix: '+258' },
    Namibia: { iso2: 'NA', iso3: 'NAM', prefix: '+264' },
    Nauru: { iso2: 'NR', iso3: 'NRU', prefix: '+674' },
    Nepal: { iso2: 'NP', iso3: 'NPL', prefix: '+977' },
    Nicaragua: { iso2: 'NI', iso3: 'NIC', prefix: '+505' },
    Niger: { iso2: 'NE', iso3: 'NER', prefix: '+227' },
    Nigeria: { iso2: 'NG', iso3: 'NGA', prefix: '+234' },
    Niue: { iso2: 'NU', iso3: 'NIU', prefix: '+683' },
    Norway: { iso2: 'NO', iso3: 'NOR', prefix: '+47' },
    'New Caledonia': { iso2: 'NC', iso3: 'NCL', prefix: '+687' },
    'New Zealand': { iso2: 'NZ', iso3: 'NZL', prefix: '+64' },
    Oman: { iso2: 'OM', iso3: 'OMN', prefix: '+968' },
    Netherlands: { iso2: 'NL', iso3: 'NLD', prefix: '+31' },
    Pakistan: { iso2: 'PK', iso3: 'PAK', prefix: '+92' },
    Palau: { iso2: 'PW', iso3: 'PLW', prefix: '+680' },
    Palestine: { iso2: 'PS', iso3: 'PSE', prefix: '+970' },
    Panama: { iso2: 'PA', iso3: 'PAN', prefix: '+507' },
    'Papua New Guinea': { iso2: 'PG', iso3: 'PNG', prefix: '+675' },
    Paraguay: { iso2: 'PY', iso3: 'PRY', prefix: '+595' },
    Peru: { iso2: 'PE', iso3: 'PER', prefix: '+51' },
    'French Polynesia': { iso2: 'PF', iso3: 'PYF', prefix: '+689' },
    Poland: { iso2: 'PL', iso3: 'POL', prefix: '+48' },
    Portugal: { iso2: 'PT', iso3: 'PRT', prefix: '+351' },
    'Puerto Rico': { iso2: 'PR', iso3: 'PRI', prefix: '+1' },
    Qatar: { iso2: 'QA', iso3: 'QAT', prefix: '+974' },
    'United Kingdom': { iso2: 'GB', iso3: 'GBR', prefix: '+44' },
    'Central African Republic': { iso2: 'CF', iso3: 'CAF', prefix: '+236' },
    'Czech Republic': { iso2: 'CZ', iso3: 'CZE', prefix: '+420' },
    'Dominican Republic': { iso2: 'DO', iso3: 'DOM', prefix: '+1 809' },
    Rwanda: { iso2: 'RW', iso3: 'RWA', prefix: '+250' },
    Romania: { iso2: 'RO', iso3: 'ROU', prefix: '+40' },
    Russia: { iso2: 'RU', iso3: 'RUS', prefix: '+7' },
    Samoa: { iso2: 'WS', iso3: 'WSM', prefix: '+685' },
    'American Samoa': { iso2: 'AS', iso3: 'ASM', prefix: '+1 684' },
    'Saint Barthélemy': { iso2: 'BL', iso3: 'BLM', prefix: '+590' },
    'Saint Kitts and Nevis': { iso2: 'KN', iso3: 'KNA', prefix: '+1 869' },
    'San Marino': { iso2: 'SM', iso3: 'SMR', prefix: '+378' },
    'Saint Martin (French part)': { iso2: 'MF', iso3: 'MAF', prefix: '+1 599' },
    'Saint Pierre and Miquelon': { iso2: 'PM', iso3: 'SPM', prefix: '+508' },
    'Saint Vincent and the Grenadines': {
        iso2: 'VC',
        iso3: 'VCT',
        prefix: '+1 784',
    },
    'Ascensión y Tristán de Acuña': { iso2: 'SH', iso3: 'SHN', prefix: '+290' },
    'Saint Lucia': { iso2: 'LC', iso3: 'LCA', prefix: '+1 758' },
    'Sao Tome and Principe': { iso2: 'ST', iso3: 'STP', prefix: '+239' },
    Senegal: { iso2: 'SN', iso3: 'SEN', prefix: '+221' },
    Serbia: { iso2: 'RS', iso3: 'SRB', prefix: '+381' },
    Seychelles: { iso2: 'SC', iso3: 'SYC', prefix: '+248' },
    'Sierra Leone': { iso2: 'SL', iso3: 'SLE', prefix: '+232' },
    Singapore: { iso2: 'SG', iso3: 'SGP', prefix: '+65' },
    Syria: { iso2: 'SY', iso3: 'SYR', prefix: '+963' },
    Somalia: { iso2: 'SO', iso3: 'SOM', prefix: '+252' },
    'Sri Lanka': { iso2: 'LK', iso3: 'LKA', prefix: '+94' },
    'South Africa': { iso2: 'ZA', iso3: 'ZAF', prefix: '+27' },
    Sudan: { iso2: 'SD', iso3: 'SDN', prefix: '+249' },
    Sweden: { iso2: 'SE', iso3: 'SWE', prefix: '+46' },
    Switzerland: { iso2: 'CH', iso3: 'CHE', prefix: '+41' },
    Suriname: { iso2: 'SR', iso3: 'SUR', prefix: '+597' },
    Swaziland: { iso2: 'SZ', iso3: 'SWZ', prefix: '+268' },
    Tajikistan: { iso2: 'TJ', iso3: 'TJK', prefix: '+992' },
    Thailand: { iso2: 'TH', iso3: 'THA', prefix: '+66' },
    Taiwan: { iso2: 'TW', iso3: 'TWN', prefix: '+886' },
    Tanzania: { iso2: 'TZ', iso3: 'TZA', prefix: '+255' },
    'East Timor': { iso2: 'TL', iso3: 'TLS', prefix: '+670' },
    Togo: { iso2: 'TG', iso3: 'TGO', prefix: '+228' },
    Tokelau: { iso2: 'TK', iso3: 'TKL', prefix: '+690' },
    Tonga: { iso2: 'TO', iso3: 'TON', prefix: '+676' },
    'Trinidad and Tobago': { iso2: 'TT', iso3: 'TTO', prefix: '+1 868' },
    Tunisia: { iso2: 'TN', iso3: 'TUN', prefix: '+216' },
    Turkmenistan: { iso2: 'TM', iso3: 'TKM', prefix: '+993' },
    Turkey: { iso2: 'TR', iso3: 'TUR', prefix: '+90' },
    Tuvalu: { iso2: 'TV', iso3: 'TUV', prefix: '+688' },
    Ukraine: { iso2: 'UA', iso3: 'UKR', prefix: '+380' },
    Uganda: { iso2: 'UG', iso3: 'UGA', prefix: '+256' },
    Uruguay: { iso2: 'UY', iso3: 'URY', prefix: '+598' },
    Uzbekistan: { iso2: 'UZ', iso3: 'UZB', prefix: '+998' },
    Vanuatu: { iso2: 'VU', iso3: 'VUT', prefix: '+678' },
    Venezuela: { iso2: 'VE', iso3: 'VEN', prefix: '+58' },
    Vietnam: { iso2: 'VN', iso3: 'VNM', prefix: '+84' },
    'Wallis and Futuna': { iso2: 'WF', iso3: 'WLF', prefix: '+681' },
    Yemen: { iso2: 'YE', iso3: 'YEM', prefix: '+967' },
    Djibouti: { iso2: 'DJ', iso3: 'DJI', prefix: '+253' },
    Zambia: { iso2: 'ZM', iso3: 'ZMB', prefix: '+260' },
    Zimbabwe: { iso2: 'ZW', iso3: 'ZWE', prefix: '+263' },
};
export default prefixes;
